import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terminos-ycondiciones',
  templateUrl: './terminos-ycondiciones.component.html',
  styleUrls: ['./terminos-ycondiciones.component.scss']
})
export class TerminosYCondicionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
